import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconZoomOut$1 = /*@__PURE__*/ proxyCustomElement(class WppIconZoomOut extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-zoom-out", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M11.3615 7.97321C11.2364 7.84817 11.0668 7.77792 10.89 7.77792H6.0004C5.82357 7.77792 5.65397 7.84817 5.52893 7.97321C5.40389 8.09825 5.33364 8.26785 5.33364 8.44468C5.33364 8.62152 5.40389 8.79111 5.52893 8.91616C5.65397 9.0412 5.82357 9.11145 6.0004 9.11145H10.89C11.0668 9.11145 11.2364 9.0412 11.3615 8.91616C11.4865 8.79111 11.5568 8.62152 11.5568 8.44468C11.5568 8.26785 11.4865 8.09825 11.3615 7.97321Z", fill: "currentColor" }), h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.4798 4.42079C14.393 5.56313 14.8906 6.98209 14.8908 8.44459C14.8932 9.92409 14.3844 11.359 13.4506 12.5065L17.8068 16.8636C17.925 16.9827 17.9939 17.1421 17.9998 17.3098C18.0057 17.4775 17.9482 17.6413 17.8386 17.7684C17.7291 17.8956 17.5757 17.9767 17.4089 17.9957C17.2422 18.0147 17.0744 17.9701 16.9391 17.8709L16.8635 17.806L12.5073 13.4498C11.3718 14.3715 9.95658 14.8795 8.49412 14.8906C7.03166 14.9017 5.60892 14.415 4.45959 13.5106C3.31025 12.6062 2.50268 11.3378 2.16949 9.91376C1.83631 8.48972 1.99734 6.9947 2.62613 5.67427C3.25491 4.35384 4.31407 3.28651 5.62963 2.64759C6.9452 2.00868 8.43893 1.83617 9.8655 2.1584C11.2921 2.48063 12.5666 3.27844 13.4798 4.42079ZM3.72265 6.48837C3.46576 7.10857 3.33353 7.77329 3.33353 8.44459C3.33353 9.80034 3.8721 11.1006 4.83076 12.0592C5.78942 13.0179 7.08965 13.5565 8.44539 13.5565C9.80114 13.5565 11.1014 13.0179 12.06 12.0592C13.0187 11.1006 13.5573 9.80034 13.5573 8.44459C13.5573 7.77329 13.425 7.10857 13.1681 6.48837C12.9112 5.86817 12.5347 5.30464 12.06 4.82996C11.5853 4.35528 11.0218 3.97875 10.4016 3.72185C9.78142 3.46496 9.11669 3.33273 8.44539 3.33273C7.7741 3.33273 7.10937 3.46496 6.48917 3.72185C5.86897 3.97875 5.30544 4.35528 4.83076 4.82996C4.35608 5.30464 3.97955 5.86817 3.72265 6.48837Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-zoom-out-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-zoom-out", "wpp-icon-zoom-out-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-zoom-out-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-zoom-out-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconZoomOut$1);
      }
      break;
  } });
}

const WppIconZoomOut = WppIconZoomOut$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconZoomOut, defineCustomElement };
